import { styled } from "@mui/material/styles";

const InnerContainer = styled("div")(`
  width: 60%;
  margin: auto;
`);

export default InnerContainer;
